import getStore from 'services/getStore';
import { cloneBlock, Block } from 'factories/block';
import { setBlockAction } from 'actions/setBlockAction';

let newBlocks = {};
let delayUpdate;

type Props = {
  [key: string]: any;
} | null;

export default (block: Block, props: Props, confirmMessage?: string) => {
  //
  if (props === null) {
    if (confirmMessage === undefined) {
      console.warn(
        '%cif setting props to null a confirm message must be provided. if you are certain that a confirm message is not needed then pass an empty string',
        'background:yellow;padding:20px'
      );
      return;
    }

    if (confirmMessage !== '') {
      if (!window.confirm(confirmMessage)) {
        return;
      }
    }
  }

  if (!newBlocks[block.id]) {
    newBlocks[block.id] = cloneBlock(block);
  }

  //

  newBlocks[block.id].props =
    props === null ? {} : { ...newBlocks[block.id].props, ...props };

  clearTimeout(delayUpdate);

  delayUpdate = setTimeout(() => {
    Object.values(newBlocks).forEach((b: any) => {
      getStore().dispatch(setBlockAction(b));
    });
    newBlocks = {};
  }, 1000 / 60);
};
